(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {

    const toggleProductSearchOnMobile = () => {
      if (window.innerWidth < 480) {
        document.querySelector('.facets-controls-wrapper .product-search-bar #showProductSearchOnMobile').onclick = () => {
          document.querySelector('.header_icons .icons_wrapper .search-action > button').click();
          document.querySelector('.predictive-search-form__header .predictive-search-form__header-inner input#cmdk-input').focus();
        };
        
        document.querySelector('.predictive-search-form__header button.button.predictive-search__close-modal-button').onclick = () => {
          document.querySelector('.predictive-search-form__header .predictive-search-form__header-inner input#cmdk-input').blur();
        };
        
      } else {
        document.querySelector('.facets-controls-wrapper .product-search-bar #showProductSearchOnMobile').onclick = () => {
          document.querySelector('.facets-controls-wrapper .product-search-bar #showProductSearchOnMobile').style.display = 'none';
          document.querySelector('.facets-controls-wrapper .product-search-bar #hideProductSearchOnMobile').style.display = 'flex';
          document.querySelector('.facets-controls-wrapper .product-search-bar predictive-search-component.predictive-search').style.display = 'block';
        };

        document.querySelector('.facets-controls-wrapper .product-search-bar #hideProductSearchOnMobile').onclick = () => {
          document.querySelector('.facets-controls-wrapper .product-search-bar #showProductSearchOnMobile').style.display = 'flex';
          document.querySelector('.facets-controls-wrapper .product-search-bar #hideProductSearchOnMobile').style.display = 'none';
          document.querySelector('.facets-controls-wrapper .product-search-bar predictive-search-component.predictive-search').style.display = 'none';
        };

        document.querySelector('.facets-controls-wrapper .product-search-bar').style.display = 'flex';
      }

      document.querySelector('body').onclick = (event) => {
        if(!event.target.closest('.product-search-bar')) {
          document.querySelector('.facets-controls-wrapper .product-search-bar .predictive-search__reset-button').click();
        }
      }

    };

    toggleProductSearchOnMobile();
    window.addEventListener('resize', toggleProductSearchOnMobile);

  })


  } catch(e) { console.error(e); }
})();
})();
